import http from "../http-common";
import authHeader from '../auth-header';

export default class PlanillaService {

    consultarLecturasCliente(idanio, idmes, idcliente){
        return http.get(`jaapzproceso/planilla/consultarlecturascliente/${idanio}/${idmes}/${idcliente}`, { headers: authHeader() });
    }

    grabarPlanilla(obj){
        return http.post(`jaapzproceso/planilla/grabarPlanilla`, obj, { headers: authHeader() });
    }

    imprimirPlanilla(idcliente, idanio, idmes){
        return http.get(`jaapzproceso/planilla/imprimirplanillaconsumo/${idcliente}/${idanio}/${idmes}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    consultarPlanillasPorCliente(idcliente){
        return http.get(`jaapzproceso/planilla/consultarplanillasporcliente/${idcliente}`, { headers: authHeader() });
    }

    eliminarPlanillaPorId(id){
        return http.get(`jaapzproceso/planilla/eliminarplanillaporid/${id}`, { headers: authHeader() });
    }

    imprimirDeudas(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirdeudas/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    consultardetalleplanilla(idcliente, idanio, idmes){
        return http.get(`jaapzproceso/planilla/consultardetalleplanilla/${idcliente}/${idanio}/${idmes}`, { headers: authHeader() });
    }

    consultardeudascliente(idcliente){
        return http.get(`jaapzproceso/planilla/consultardeudascliente/${idcliente}`, { headers: authHeader() });
    }

    grabarDetallePlanilla(obj){
        return http.post(`jaapzproceso/planilla/grabardetalleplanilla`, obj, { headers: authHeader() });
    }

    eliminarDetallePlanilla(obj){
        return http.post(`jaapzproceso/planilla/eliminardetalleplanilla`, obj, { headers: authHeader() });
    }

    imprimirTomaLectura(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirreportetomalecturas/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    imprimirConsolidadoConsumo(idmes, idanio, mes, anio){
        return http.get(`jaapzproceso/planilla/imprimirreporteconsolidadoconsumo/${idmes}/${idanio}/${mes}/${anio}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    consultarplanilla(idanio, idmes){
        return http.get(`jaapzproceso/planilla/consultarplanilla/${idanio}/${idmes}`, { headers: authHeader() });
    }

    consultarplanillafirmada(idanio, idmes){
        return http.get(`jaapzproceso/planilla/consultarplanillafirmada/${idanio}/${idmes}`, { headers: authHeader() });
    }

    consultarplanillafirmadaporestado(idanio, idmes, estado){
        return http.get(`jaapzproceso/planilla/consultarplanillafirmadaporestado/${idanio}/${idmes}/${estado}`, { headers: authHeader() });
    }

    consultarplanillarecibidas(idanio, idmes){
        return http.get(`jaapzproceso/planilla/consultarplanillarecibidas/${idanio}/${idmes}`, { headers: authHeader() });
    }

    firmarfacturamasiva(obj){
        return http.post(`jaapzproceso/planilla/firmarfacturamasiva`, obj, { headers: authHeader() });
    }

    enviarcomprobante(obj){
        return http.post(`jaapzproceso/planilla/enviarcomprobante`, obj, { headers: authHeader() });
    }

    autorizarcomprobante(obj){
        return http.post(`jaapzproceso/planilla/autorizarcomprobante`, obj, { headers: authHeader() });
    }

    imprimirfacturasri( id ){
        return http.get(`jaapzproceso/planilla/imprimirfacturasri/${id}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    enviarCorreoMasivo( obj ){
        return http.post(`jaapzproceso/planilla/enviarCorreoMasivo`, obj, { headers: authHeader() });
    }

    imprimirHistorialUsuario(idcliente, anio){
        return http.get(`jaapzproceso/planilla/imprimirreportehistorialusuario/${idcliente}/${anio}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    imprimirUsuarioOrdenCorte(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirusuarioordencorte/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    imprimirUsuarioAlDia(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirusuarioaldia/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    imprimirNominaConsumidores(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirnominaconsumidores/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    imprimirNominaConsumidoresFirmar(){
        let user = JSON.parse(localStorage.getItem('user'));
        return http.get(`jaapzproceso/planilla/imprimirnominaconsumidoresfirmar/${user.usuario}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }
}